import { ref, computed } from 'vue'
import normalizar from './normalizar'

export default function usePesquisaGeral(opcoes = {}) {
  const { tratarEscape = false } = opcoes

  const termoBusca = ref('')
  const dropdownAberto = ref(false)
  const submenus = ref([])
  const inputRef = ref(null)
  const indiceAtivo = ref(-1)
  const itensRefs = ref([])

  function traduzir(chave, fallback = '') {
    if (typeof window !== 'undefined' && typeof window.t === 'function') {
      return window.t(chave)
    }
    return fallback
  }

  const mensagemPlanoNaoCobre = computed(() =>
    traduzir('interface.pesquisa_geral.mensagem_plano_nao_cobre')
  )

  const mensagemSemAcesso = computed(() =>
    traduzir('interface.pesquisa_geral.sem_acesso')
  )

  const placeholderPesquisando = computed(() =>
    traduzir('interface.pesquisa_geral.placeholder_pesquisando', 'Qual funcionalidade você está procurando?')
  )

  const resultadosFiltrados = computed(() => {
    if (!termoBusca.value || termoBusca.value.trim() === '') {
      return []
    }
    const termoNormalizado = normalizar(termoBusca.value)
    return submenus.value.filter(
      (item) => normalizar(item.description).includes(termoNormalizado)
    )
  })

  function mensagemTooltip(item) {
    if (!item.no_plano) {
      return mensagemPlanoNaoCobre.value
    }
    if (!item.has_submenu) {
      return mensagemSemAcesso.value
    }
    return null
  }

  function carregarSubmenus() {
    const elementoDados = document.getElementById('data-submenus')
    if (elementoDados) {
      try {
        submenus.value = JSON.parse(elementoDados.textContent)
      } catch (erro) {
        console.error('Falha ao carregar dados de pesquisa', erro)
        submenus.value = []
      }
    }
  }

  function aoDigitar(evento) {
    indiceAtivo.value = -1
    termoBusca.value = evento.target.value
    dropdownAberto.value = termoBusca.value.length > 0
  }

  function aoLimpar() {
    termoBusca.value = ''
    dropdownAberto.value = false
    indiceAtivo.value = -1
    if (inputRef.value) {
      inputRef.value.focus()
    }
  }

  function aoClicarResultado(evento, item) {
    if (!item.has_submenu) {
      evento.preventDefault()
    }
  }

  function setItemRef(el, indice) {
    if (el) {
      itensRefs.value[indice] = el
    }
  }

  function scrollItemAtivoParaVisao() {
    const elemento = itensRefs.value[indiceAtivo.value]
    if (elemento && typeof elemento.scrollIntoView === 'function') {
      elemento.scrollIntoView({ block: 'nearest' })
    }
  }

  function aoMoverMouse() {
    if (indiceAtivo.value !== -1) {
      indiceAtivo.value = -1
    }
  }

  function aoApertarTecla(evento) {
    if (tratarEscape && evento.key === 'Escape') {
      dropdownAberto.value = false
      indiceAtivo.value = -1
      return
    }

    const total = resultadosFiltrados.value.length
    if (total === 0) return

    if (evento.key === 'ArrowDown') {
      evento.preventDefault()
      indiceAtivo.value = (indiceAtivo.value + 1) % total
      scrollItemAtivoParaVisao()
    } else if (evento.key === 'ArrowUp') {
      evento.preventDefault()
      indiceAtivo.value = indiceAtivo.value === -1
        ? total - 1
        : (indiceAtivo.value - 1 + total) % total
      scrollItemAtivoParaVisao()
    } else if (evento.key === 'Enter') {
      if (indiceAtivo.value >= 0) {
        const item = resultadosFiltrados.value[indiceAtivo.value]
        if (item.has_submenu) {
          window.location.href = `/${item.action}`
        }
      }
    }
  }

  return {
    termoBusca,
    dropdownAberto,
    submenus,
    inputRef,
    indiceAtivo,
    itensRefs,
    mensagemPlanoNaoCobre,
    mensagemSemAcesso,
    placeholderPesquisando,
    resultadosFiltrados,
    traduzir,
    mensagemTooltip,
    carregarSubmenus,
    aoDigitar,
    aoLimpar,
    aoClicarResultado,
    setItemRef,
    scrollItemAtivoParaVisao,
    aoMoverMouse,
    aoApertarTecla,
  }
}
